export const getParentFolderId = (parentFolderId: string) => {
  return parentFolderId === 'LIBRARY_ROOT_FOLDER_ID' ? '' : parentFolderId;
};
